import React, { PropsWithChildren, ReactNode, useState } from 'react'
import { Button, ButtonProps } from '../Button/Button'
import { ButtonGroup, Dropdown } from 'react-bootstrap'
import classNames from 'classnames'
import './SplitButton.scss'

interface SplitButtonProps extends ButtonProps {
  label: ReactNode
}

export const SplitButton: React.FC<PropsWithChildren<SplitButtonProps>> = ({ children, label, ...props }) => {
  const { variant, disabled, loading } = props

  const [isOpen, setOpen] = useState<boolean>(false)

  return (
    <Dropdown
      as={ButtonGroup}
      drop='down'
      className={classNames('d-flex align-items-center split-button-container', {
        'zocks-bg-color-gray-200': disabled || loading,
        'zocks-bg-color-primary': !disabled && !loading,
      })}
      onToggle={() => setOpen((open) => !open)}
    >
      <Button className='primary-button' {...props}>
        {label}
      </Button>
      <div className='d-flex split-button-divider' />
      <Dropdown.Toggle id='dropdown-split' as={Button} className='split-dropdown-button zocks-py-0.75' split disabled={disabled || loading} variant={variant}>
        <i className={classNames('bi', { 'bi-chevron-expand': !isOpen, 'bi-chevron-contract': isOpen })} />
      </Dropdown.Toggle>

      <Dropdown.Menu
        align='end'
        className={classNames('split-dropdown p-2 gap-1 w-100', {
          'zocks-bg-color-gray-200': disabled || loading,
          'zocks-bg-color-primary': !disabled && !loading,
        })}
      >
        {children}
      </Dropdown.Menu>
    </Dropdown>
  )
}
